<template>
  <div :class="`card ${bd} ${mgt} bd-none`" v-if="dashboardData.rdy">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">Осол саадын тоо</h6>
      <nav class="nav nav-row-xs align-items-center">
        <a
          @click="
            dashboardData.params.mode = 1;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 1 ? 'active' : ''}`"
          role="button"
          >1D</a
        >
        <a
          @click="
            dashboardData.params.mode = 2;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 2 ? 'active' : ''}`"
          role="button"
          >1W</a
        >
        <a
          @click="
            dashboardData.params.mode = 3;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 3 ? 'active' : ''}`"
          role="button"
          >1M</a
        >
        <a
          @click="
            dashboardData.params.mode = 4;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 4 ? 'active' : ''}`"
          role="button"
          >1Y</a
        >
      </nav>
    </div>

    <div class="card-body pd-0">
      <div class="row mg-b-20">
        <div class="col text-center">
          <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-10">
            {{
              dashboardData.data.groupedData
                .filter((x) => x.typeId == 152152)
                .reduce((sum, { count }) => sum + parseInt(count), 0)
            }}
          </h4>
          <p class="tx-11 tx-uppercase tx-spacing-1 tx-medium tx-color-03">
            Осол
          </p>
        </div>
        <div class="col  text-center">
          <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-10">
            {{
              dashboardData.data.groupedData
                .filter((x) => x.typeId == 152153)
                .reduce((sum, { count }) => sum + parseInt(count), 0)
            }}
          </h4>
          <p class="tx-11 tx-uppercase tx-spacing-1 tx-medium tx-color-03">
            Саад
          </p>
        </div>
      </div>
      <div>
        <apexchart
          type="bar"
          height="250"
          :options="dashboardData.chart.options"
          :series="dashboardData.chart.series"
          :key="dashboardData.chart.key"
        ></apexchart>
      </div>
    </div>
    <div class="card-footer tx-11 tx-color-03 d-flex">
      <div>
        Хамрах хугацаа:
        {{ dashboardData.data.processed.startDate | moment("YYYY.MM.DD") }}
        -
        {{ dashboardData.data.processed.endDate | moment("YYYY.MM.DD") }}<br />
        Боловсруулсан:
        {{ dashboardData.data.processed.time.toFixed(2) }}сек
      </div>

      <div class="mg-l-auto">
        <a @click="filterDateObj.mdl= true;" class="btn btn-primary">
          <feather type="filter"></feather>
          Огноо
        </a>
      </div>
    </div>
    
    <filter-date @do-search="doSearch" :mdl="filterDateObj.mdl" @on-hide="filterDateObj.mdl= false"></filter-date>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";
const moment = require("moment");
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    apexchart: VueApexCharts,

    filterDate: () => ({
      component: import("@/views/apps/penalty/components/filterDate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  props: {
    mgt: {
      type: String,
      default: () => "",
    },
    bd: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      filterDateObj: {
        mdl: false,
        d1: null,
        d2: null
      },

      dashboardData: {
        chart: {
          key: 0,
          series: [
            {
              name: "осол",
              data: [],
            },
            {
              name: "саад",
              data: [],
            },
          ],
          options: {
            chart: {
              height: 150,
              type: "line",
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "straight",
            },
            grid: {
              row: {
                colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                opacity: 0.5,
              },
            },
            xaxis: {
              categories: [],
            },
          },
        },
        rdy: false,
        params: {
          mode: 4,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          list: [],
        },
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    doSearch(e){
      this.dashboardData.params.startDate= e.d1;
      this.dashboardData.params.endDate= e.d2;
      this.dashboardData.params.mode= 0;
      this.loadData();
    },
    loadData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "TrafficData/GetAccidentData" },
        params: {
          mode: this.dashboardData.params.mode,
          startDate: this.dashboardData.params.startDate,
          endDate: this.dashboardData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.dashboardData.data = res.data;
          this.dashboardData.chart.series[0].data = this.dashboardData.data.groupedData
            .filter((x) => x.typeId == 152152)
            .map((x) => {
              return x.count;
            });
          this.dashboardData.chart.series[1].data = this.dashboardData.data.groupedData
            .filter((x) => x.typeId == 152153)
            .map((x) => {
              return x.count;
            });
          this.dashboardData.chart.options.xaxis.categories = this.dashboardData.data.districts.map(
            (x) => {
              return x.name;
            }
          );
          this.dashboardData.chart.key++;
          this.dashboardData.rdy = true;
        }
      });
    },
  },
};
</script>

<style></style>
